export default "__VITE_ASSET__Bto$T$oy__"